import React from "react";

export interface Emoji {
  icon: string;
  label: string;
  value: string;
}

interface EmojiSelectorProps {
  selectedEmoji: string;
  onSelectEmoji: (value: string) => void;
}

const emojis: Emoji[] = [
  { icon: "😭", label: "Dissatisfied", value: "dissatisfied" },
  { icon: "😔", label: "Somewhat Dissatisfied", value: "somewhat_dissatisfied" },
  { icon: "😐", label: "Neutral", value: "neutral" },
  { icon: "🙂", label: "Somewhat Satisfied", value: "somewhat_satisfied" },
  { icon: "🤩", label: "Satisfied", value: "satisfied" },
];

const EmojiSelector: React.FC<EmojiSelectorProps> = ({ selectedEmoji, onSelectEmoji }) => {
  return (
    <div className="feedback-emojis">
      {emojis.map((emoji) => (
        <button
          key={emoji.value}
          type="button"
          className={`emoji-button ${selectedEmoji === emoji.value ? "active" : ""}`}
          onClick={() => onSelectEmoji(selectedEmoji === emoji.value ? "" : emoji.value)}
          aria-label={emoji.label}
        >
          <span className="emoji-icon">{emoji.icon}</span>
          <span className="emoji-label">
            {emoji.label === "Somewhat Dissatisfied"
              ? "Dissatisfied"
              : emoji.label === "Somewhat Satisfied"
              ? "Satisfied"
              : emoji.label}
          </span>
        </button>
      ))}
    </div>
  );
};

export default EmojiSelector;
